export interface Reward {
  day: number;
  points: number;
}

export const DAILY_REWARDS: Reward[] = [
  { day: 1, points: 100 },
  { day: 2, points: 150 },
  { day: 3, points: 200 },
  { day: 4, points: 250 },
  { day: 5, points: 300 },
  { day: 6, points: 350 },
  { day: 7, points: 500 }
];
